import React from 'react';
import fallbackImage from '../../assets/img/ImgFV.jpg';
import './ProductFallbackImage.scss';

const ProductFallbackImage = () => (
  <div className="image-wrapper">
    <img
      src={fallbackImage}
      alt="Product fallback"
      className="fallback-image"
    />
  </div>
);

export default ProductFallbackImage;
